// extracted by mini-css-extract-plugin
export var popper = "_8j-0";